import FormSubmissionList from '@/modules/forms/FormSubmissionList';

export default [
	{
		path: '/forms',
		name: 'Submissions',
		component: FormSubmissionList,
	}
]